module.exports = __webpack_public_path__ + "img/search.66d9ebd4.svg";